import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

export const PUSH_TOKEN_STORAGE_KEY = 'push_token';
export const PUSH_TOKEN_USER_STORAGE_KEY = 'push_token_user';

export async function getStoredPushToken() {
  if (Platform.OS === 'web') {
    return null;
  }

  const token = (await SecureStore.getItemAsync(PUSH_TOKEN_STORAGE_KEY))?.trim();
  return token ? token : null;
}

export async function storePushToken(token: string, userId: string) {
  if (Platform.OS === 'web') {
    return;
  }

  await Promise.all([
    SecureStore.setItemAsync(PUSH_TOKEN_STORAGE_KEY, token),
    SecureStore.setItemAsync(PUSH_TOKEN_USER_STORAGE_KEY, userId),
  ]);
}

export async function getStoredPushTokenUser() {
  if (Platform.OS === 'web') {
    return null;
  }

  const userId = (
    await SecureStore.getItemAsync(PUSH_TOKEN_USER_STORAGE_KEY)
  )?.trim();
  return userId ? userId : null;
}

export async function clearStoredPushToken() {
  if (Platform.OS === 'web') {
    return;
  }

  await Promise.all([
    SecureStore.deleteItemAsync(PUSH_TOKEN_STORAGE_KEY),
    SecureStore.deleteItemAsync(PUSH_TOKEN_USER_STORAGE_KEY),
  ]);
}
